export default {"src":"/_next/static/media/visa-logo.05ae4f07.svg","height":325,"width":1000,"blurWidth":0,"blurHeight":0};